export default "__VITE_ASSET__52bf6c20__"